export function getEventDate(createdAt: string | Date | null | undefined): Date {
  const date = createdAt ? new Date(createdAt) : new Date(0)
  return isNaN(date.getTime()) ? new Date(0) : date
}

export function timeSince(createdAt: string | Date | null | undefined) {
  const date = getEventDate(createdAt)
  if (date.getTime() === 0) return ''

  const now = new Date()
  const seconds: number = Math.floor((+now - +date) / 1000)

  const intervals = [
    { label: 'y', seconds: 31536000 },
    { label: 'mo', seconds: 2592000 },
    { label: 'w', seconds: 604800 },
    { label: 'd', seconds: 86400 },
    { label: 'h', seconds: 3600 },
    { label: 'm', seconds: 60 },
    { label: 's', seconds: 1 },
  ]

  for (let interval of intervals) {
    const count = Math.floor(seconds / interval.seconds)
    if (count > 0) {
      return `${count}${interval.label}`
    }
  }

  return 'now'
}
